import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  orgSnowflakeApproveUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type {
  ApproveSnowflakePayload,
  ApproveSnowflakeResponse,
} from '@/lib/portfolio/snowflake-types';

interface ApproveSnowflakeRequestParams {
  requestId: number;
  payload: ApproveSnowflakePayload;
}

export function useApproveSnowflakeRequest(orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ requestId, payload }: ApproveSnowflakeRequestParams) =>
      apiPost<ApproveSnowflakeResponse>(
        orgSnowflakeApproveUrl(orgId, requestId),
        payload
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgSnowflakeRequests(orgId),
      });
    },
  });
}
